// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kpi[data-v-fc7496b4] {
  color: var(--text-color);
  display: flex;
  justify-content: space-between;
  padding: 5px 20px;
}
.kpi h2[data-v-fc7496b4] {
  margin: 0;
  display: inline-block;
  font-size: 40px;
}
.kpi i[data-v-fc7496b4] {
  margin-left: auto;
  font-size: 40px;
}`, "",{"version":3,"sources":["webpack://./js/vueComponents/dashboardContainer/src/panels/KPI.vue","webpack://./KPI.vue"],"names":[],"mappings":"AACA;EACE,wBAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;ACAF;ADCE;EACE,SAAA;EACA,qBAAA;EACA,eAAA;ACCJ;ADCE;EACE,iBAAA;EACA,eAAA;ACCJ","sourcesContent":["\n.kpi {\n  color: var(--text-color);\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 20px;\n  h2 {\n    margin: 0;\n    display: inline-block;\n    font-size: 40px;\n  }\n  i {\n    margin-left: auto;\n    font-size: 40px;\n  }\n}\n",".kpi {\n  color: var(--text-color);\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 20px;\n}\n.kpi h2 {\n  margin: 0;\n  display: inline-block;\n  font-size: 40px;\n}\n.kpi i {\n  margin-left: auto;\n  font-size: 40px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
